<template>
  <DxPopup
    :visible.sync="visibleLocal"
    :show-title="true"
    :title="title"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :width="popupWidth"
    :height="popupHeight"
  >
    <div class="lot-popup-content">
      <div class="lot-popup-message">{{ message }}</div>

      <div v-if="mode === 'select'" class="lot-options-list">
        <div
          v-for="lot in lotOptions"
          :key="lot"
          class="lot-option-item"
          :class="{ selected: selectedLot === lot }"
          @click="selectLot(lot)"
        >
          {{ lot }}
        </div>
      </div>

      <div v-else class="lot-input-wrap">
        <DxTextBox
          v-model="manualLot"
          :placeholder="inputPlaceholder"
          class="global_dx_textbox"
        />
      </div>

      <div class="lot-actions">
        <SmagriaButton :label="confirmText" customClass="primary" :disabled="confirmDisabled" :action="confirmSelection" />
        <SmagriaButton v-if="showContinueWithoutLot" :label="continueWithoutLotText" customClass="secondary border" :action="continueWithoutLot" />
        <SmagriaButton :label="cancelProcessText" customClass="reset border" :action="cancelSavingProcess" />
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import DxTextBox from "devextreme-vue/text-box";
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: "LotNumberResolvePopup",
  components: {
    DxPopup,
    DxTextBox,
    SmagriaButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Lot number",
    },
    message: {
      type: String,
      default: "Select lot number",
    },
    mode: {
      type: String,
      default: "select", // select | input
    },
    lotOptions: {
      type: Array,
      default: () => [],
    },
    inputPlaceholder: {
      type: String,
      default: "Lot number",
    },
    confirmText: {
      type: String,
      default: "Save",
    },
    continueWithoutLotText: {
      type: String,
      default: "Continue without lot",
    },
    cancelProcessText: {
      type: String,
      default: "Cancel save",
    },
    width: {
      type: Number,
      default: 380,
    },
    height: {
      type: Number,
      default: 360,
    },
    showContinueWithoutLot: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visibleLocal: this.value,
      manualLot: "",
      selectedLot: "",
    };
  },
  computed: {
    popupWidth() {
      const screenWidth = window?.innerWidth || this.width;
      return Math.min(this.width, screenWidth - 24);
    },
    popupHeight() {
      const screenHeight = window?.innerHeight || this.height;
      return Math.min(this.height, screenHeight - 40);
    },
    confirmDisabled() {
      if (this.mode !== "select") {
        return false;
      }
      return !(this.selectedLot || "").trim();
    },
  },
  watch: {
    value(newVal) {
      this.visibleLocal = newVal;
      if (!newVal) {
        this.manualLot = "";
        this.selectedLot = "";
      }
    },
    visibleLocal(newVal) {
      this.$emit("input", newVal);
      if (!newVal) {
        this.$emit("close");
      }
    },
  },
  methods: {
    selectLot(lot) {
      this.selectedLot = (lot || "").trim();
    },
    confirmSelection() {
      const value = this.mode === "select" ? this.selectedLot : this.manualLot;
      this.$emit("resolved", {
        action: "confirm",
        value: (value || "").trim(),
      });
      this.visibleLocal = false;
    },
    continueWithoutLot() {
      this.$emit("resolved", {
        action: "continue_without_lot",
        value: "",
      });
      this.visibleLocal = false;
    },
    cancelSavingProcess() {
      this.$emit("resolved", {
        action: "cancel_save",
        value: "",
      });
      this.visibleLocal = false;
    },
  },
};
</script>

<style scoped>
.lot-popup-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 4px;
}

.lot-popup-message {
  font-size: 14px;
  color: #4a4a4a;
}

.lot-options-list {
  max-height: 180px;
  overflow: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.lot-option-item {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  font-size: 14px;
}

.lot-option-item:last-child {
  border-bottom: none;
}

.lot-option-item:hover {
  background: #f5f8fb;
}

.lot-option-item.selected {
  background: #e8f2fb;
  color: #1a4f7a;
  font-weight: 700;
}

.lot-input-wrap {
  padding: 6px 0;
}

.lot-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
}
</style>
